import { render, staticRenderFns } from "./JwJiaocaiPutoutModal.vue?vue&type=template&id=32f453d6"
import script from "./JwJiaocaiPutoutModal.vue?vue&type=script&lang=js"
export * from "./JwJiaocaiPutoutModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports